import { gql } from '@apollo/client'
import { mutate } from '../helpers/graphql'

export async function upsertFloorPlanImage(payload) {
  return mutate(
    {
      unitPlans: [payload],
    },
    gql`
      mutation Upsert_unit_plans($unitPlans: [unit_plans_input]) {
        upsert_unit_plans(unit_plans: $unitPlans) {
          id
        }
      }
    `,
  )
}
